const Files = () => import('vue-cloud/components/Files');

function install(Vue) {
  if (install.installed) return;

  install.installed = true;

  Vue.component('files', Files);
}

export default {
  install
};
